import { transition } from "./common-style";

const appMainStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100%)`
    },
    display: "flex",
    justifyContent: "center",
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    minHeight: "100vh",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    padding: "0px",
    width: "100%"
  }
});

export default appMainStyle;
